import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=215a6e2b"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports